















import { Vue, Component } from 'vue-property-decorator'

const config = {
  name: 'icon-download',
  components: {}
}

@Component(config)
export default class IconDownload extends Vue {}
